import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Form as BootstrapForm } from "react-bootstrap";
import formatCnpj from "@brazilian-utils/format-cnpj";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

import {
  Textfield,
  NextButton,
  ErrorMessage,
  Label,
} from "./styles";
import api from "~/services/api";
import { createNerdMonsterUnit } from "~/services/nerdmonster";

function Document(props) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const SignUpSchema = Yup.object().shape({
    erpCode: Yup.string().required("Preencha o Código do Cliente"),
    document: Yup.string()
      .required("Preencha seu CNPJ")
      .min(18, "Informe um CNPJ válido"),
  });

  function handleErpCode(e, handleChange) {
    const event = e;
    const numbers = event.target.value.replace(/[^\d]/g, "");
    event.target.value = event.target.value.replace(/[^\d]/g, "");
    if (numbers.length === 30) {
      event.target.value = numbers;
    }
    return handleChange(event);
  }

  function handleDocument(e, handleChange) {
    const event = e;
    const numbers = event.target.value.replace(/[^\d]/g, "");
    event.target.value = event.target.value.replace(/[^\d]/g, "");

    event.target.value = formatCnpj(numbers);
    return handleChange(event);
  }

  function handleSubmit(values) {
    const identificationCode = `${values.erpCode}`;
    const header = {
      "Content-Type": "application/json",
      "Accept-Language": "pt-BR",
    };
    const parameters = {
      method: "POST",
      headers: header,
    };
    const body = {
      storeCode: identificationCode,
      storeDocument: `${values.document
        .split(".")
        .join("")
        .split("/")
        .join("")
        .split("-")
        .join("")}`,
    };


    api
      .post("residential/store/v1/users/first-access-registration", body, parameters)
      .then(async (res) => {
        const dataRes = res?.data;
        const firstAccessToken = dataRes?.firstAccessToken;
        const userId = dataRes?.userId;
        const emails = dataRes?.emails || [];
        const phones = dataRes?.phones || [];
        const files = dataRes?.files || {};
        const location = `residential/store/v1/users/${userId}`;

        dispatch({
          type: "ADD_LOCATION",
          location: location,
        });
        dispatch({
          type: "ADD_FIRST_ACCESS_TOKEN",
          firstAccessToken: firstAccessToken,
        });
        dispatch({
          type: "ADD_FILES",
          files: files,
        });
        localStorage.setItem("userId", userId);

        // Criar Unit na NerdMonster usando dados do response
        try {
          // Usar dados retornados diretamente do first-access-registration
          // O response tem: storeName, storeAddress, phones, emails
          const storeAddress = dataRes?.storeAddress || {};

          // Preparar body para criar Unit
          const unitBody = {
            unitNickname: dataRes?.storeName || "",
            identificationCode: identificationCode || "",
            primaryPhone: phones && phones[0]?.contact || "",
            secondaryPhone: phones && phones[1]?.contact || "",
            tertiaryPhone: phones && phones[2]?.contact || "",
            openingDate: "",
            street: storeAddress?.street || "",
            number: storeAddress?.number || "",
            complement: storeAddress?.complement || "",
            neighborhood: storeAddress?.neighborhood || "",
            city: storeAddress?.city || "",
            state: storeAddress?.state || "",
            postalCode: storeAddress?.postal_code || "",
            whatsappNumber: "",
          };

          const unitHeader = {
            "Content-Type": "application/json",
            "X-First-Access-Token": firstAccessToken,
          };
          const unitParameters = {
            method: "POST",
            headers: unitHeader,
          };

          await createNerdMonsterUnit(unitBody, unitParameters);
          console.log("Unit criada na NerdMonster com sucesso");
        } catch (error) {
          console.error("Erro ao criar Unit na NerdMonster:", error);
          // Não bloquear o fluxo se falhar - apenas logar o erro
        }

        if (emails.length === 0 && phones.length === 0) {
          dispatch({ type: "STEP", step: 7 });
        } else if (emails.length > 0) {
          dispatch({
            type: "ADD_EMAILSLIST",
            emailsList: emails,
          });
          dispatch({ type: "STEP", step: 2 });
        } else {
          dispatch({
            type: "ADD_PHONESLIST",
            phonesList: phones,
          });
          dispatch({ type: "STEP", step: 3 });
        }
        setLoading(false);
      })
      .catch((err) => {
        if (err.response.status === 422) {
          toast.error("Código do cliente e documento não são correspondentes");
        } else if (err.response.status === 400) {
          toast.error("O campo de CNPJ está incorreto");
        }
        setLoading(false);
      });
  }

  return (
    <Formik
      initialValues={{ document: "", erpCode: "" }}
      onSubmit={(values) => {
        setLoading(true);
        handleSubmit(values);
      }}
      validationSchema={SignUpSchema}
    >
      {({ handleChange, handleBlur, values, errors, touched }) => (
        <Form style={{width: '100%'}} autocomplete="off">
          <BootstrapForm.Group controlId="erpCode">
            <Label>Código do Cliente</Label>
            <Field
              render={() => {
                return (
                  <Textfield
                    id="erpCode"
                    type="text"
                    label="Código do Cliente"
                    arial-label="Código do Cliente"
                    aria-required
                    errorCondition={errors.erpCode && touched.erpCode}
                    errorMessage={errors.erpCode}
                    title="Código do Cliente"
                    onBlur={handleBlur}
                    placeholder="Código do Cliente"
                    value={values.erpCode}
                    onChange={(e) => handleErpCode(e, handleChange)}
                  />
                );
              }}
              name="erpCode"
            />
            {errors.erpCode && touched.erpCode ? (
              <ErrorMessage>{errors.erpCode}</ErrorMessage>
            ) : null}
          </BootstrapForm.Group>
          <BootstrapForm.Group controlId="document">
            <Label>CNPJ</Label>
            <Field
              render={() => {
                return (
                  <Textfield
                    id="document"
                    type="text"
                    label="CNPJ"
                    arial-label="Seu CNPJ"
                    aria-required
                    errorCondition={errors.document && touched.document}
                    errorMessage={errors.document}
                    title="Seu CNPJ"
                    onBlur={handleBlur}
                    placeholder="Seu CNPJ"
                    value={values.document}
                    onChange={(e) => handleDocument(e, handleChange)}
                  />
                );
              }}
              name="document"
            />
            {errors.document && touched.document ? (
              <ErrorMessage>{errors.document}</ErrorMessage>
            ) : null}
          </BootstrapForm.Group>
          <NextButton type="submit" disabled={loading}>
            {loading ? (
              <i
                className="fa fa-spinner fa-pulse fa-3x fa-fw"
                style={{ fontSize: "1.3rem" }}
              />
            ) : (
              <span>Avançar</span>
           )}
          </NextButton>
        </Form>
      )}
    </Formik>
  );
}

export default Document;
